/* OWNLUXE: Reusable, Theme Editor-controlled infinite scrolling. */
(function() {
  function findRoots(context) {
    var roots = [];
    if (context && context.matches && context.matches('[data-ownluxe-infinite-scroll]')) {
      roots.push(context);
    }
    if (context && context.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(context.querySelectorAll('[data-ownluxe-infinite-scroll]')));
    }
    return roots;
  }

  function safeInstanceSelector(instance) {
    return '[data-ownluxe-infinite-scroll][data-infinite-instance="' + String(instance).replace(/"/g, '\\"') + '"]';
  }

  function InfiniteScroll(root) {
    this.root = root;
    this.grid = root.querySelector('[data-infinite-grid]');
    this.pagination = root.querySelector('[data-infinite-pagination]');
    this.status = root.querySelector('[data-infinite-status]');
    this.statusText = root.querySelector('[data-infinite-status-text]');
    this.spinner = root.querySelector('[data-infinite-spinner]');
    this.summary = root.querySelector('[data-infinite-summary]');
    this.instance = root.getAttribute('data-infinite-instance') || '';
    this.sectionId = root.getAttribute('data-section-id') || '';
    this.loadingText = root.getAttribute('data-loading-text') || 'Loading more items…';
    this.endText = root.getAttribute('data-end-text') || 'You have reached the end.';
    this.errorText = root.getAttribute('data-error-text') || 'More items could not be loaded. Use the page links below.';
    this.rootMargin = Number(root.getAttribute('data-trigger-offset')) || 600;
    this.maxItems = Number(root.getAttribute('data-max-items')) || 0;
    this.summaryStart = Number(root.getAttribute('data-summary-start')) || 1;
    this.totalItems = Number(root.getAttribute('data-total-items')) || 0;
    this.singularLabel = root.getAttribute('data-summary-singular') || 'item';
    this.pluralLabel = root.getAttribute('data-summary-plural') || 'items';
    this.loading = false;
    this.observer = null;
  }

  InfiniteScroll.prototype.getItems = function() {
    if (!this.grid) return [];
    return Array.prototype.slice.call(this.grid.querySelectorAll('[data-infinite-item]'));
  };

  InfiniteScroll.prototype.getNextUrl = function(scope) {
    var next = (scope || this.root).querySelector('[data-infinite-next]');
    return next ? next.getAttribute('href') : '';
  };

  InfiniteScroll.prototype.setStatus = function(text, isLoading) {
    if (!this.status) return;
    this.status.hidden = false;
    if (this.statusText) this.statusText.textContent = text || '';
    if (this.spinner) this.spinner.hidden = !isLoading;
  };

  InfiniteScroll.prototype.updateSummary = function() {
    if (!this.summary) return;
    var count = this.getItems().length;
    var end = count ? this.summaryStart + count - 1 : 0;
    var total = this.totalItems || end;
    var label = total === 1 ? this.singularLabel : this.pluralLabel;
    this.summary.textContent = 'Showing ' + (count ? this.summaryStart : 0) + '–' + end + ' of ' + total + ' ' + label + '.';
  };

  InfiniteScroll.prototype.finish = function() {
    if (this.observer && this.status) this.observer.unobserve(this.status);
    if (this.pagination) this.pagination.hidden = true;
    this.setStatus(this.endText, false);
    this.updateSummary();
  };

  InfiniteScroll.prototype.fail = function() {
    if (this.observer && this.status) this.observer.unobserve(this.status);
    if (this.pagination) this.pagination.hidden = false;
    this.setStatus(this.errorText, false);
  };

  InfiniteScroll.prototype.loadMore = function() {
    var self = this;
    var nextUrl = this.getNextUrl();
    if (this.loading || !nextUrl) {
      if (!nextUrl) this.finish();
      return;
    }

    this.loading = true;
    if (this.observer && this.status) this.observer.unobserve(this.status);
    this.setStatus(this.loadingText, true);

    var fetchUrl = new URL(nextUrl, window.location.origin);
    var currentUrl = new URL(window.location.href);

    /* Preserve template, search, filter, and other page context parameters that pagination links might omit. */
    currentUrl.searchParams.forEach(function(value, key) {
      if (!fetchUrl.searchParams.has(key) && key !== 'section_id') {
        fetchUrl.searchParams.append(key, value);
      }
    });

    if (this.sectionId) fetchUrl.searchParams.set('section_id', this.sectionId);

    fetch(fetchUrl.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Infinite-scroll request failed');
        return response.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sourceRoot = doc.querySelector(safeInstanceSelector(self.instance));
        if (!sourceRoot) throw new Error('Infinite-scroll response was missing its product grid');

        var sourceGrid = sourceRoot.querySelector('[data-infinite-grid]');
        if (!sourceGrid || !self.grid) throw new Error('Infinite-scroll response was missing items');

        var incoming = Array.prototype.slice.call(sourceGrid.querySelectorAll('[data-infinite-item]'));
        var currentCount = self.getItems().length;
        if (self.maxItems > 0) incoming = incoming.slice(0, Math.max(0, self.maxItems - currentCount));

        var fragment = document.createDocumentFragment();
        incoming.forEach(function(item) {
          fragment.appendChild(document.importNode(item, true));
        });
        self.grid.appendChild(fragment);
        document.dispatchEvent(new CustomEvent('ownluxe:products:added', { detail: { root: self.grid } }));

        var sourcePagination = sourceRoot.querySelector('[data-infinite-pagination]');
        if (self.pagination && sourcePagination) {
          self.pagination.innerHTML = sourcePagination.innerHTML;
          self.pagination.hidden = true;
        }

        self.loading = false;
        self.updateSummary();

        var reachedMaximum = self.maxItems > 0 && self.getItems().length >= self.maxItems;
        if (reachedMaximum || !self.getNextUrl()) {
          self.finish();
          return;
        }

        self.setStatus('', false);
        if (self.observer && self.status) self.observer.observe(self.status);
      })
      .catch(function() {
        self.loading = false;
        self.fail();
      });
  };

  InfiniteScroll.prototype.init = function() {
    if (!this.grid || !this.status || this.root.getAttribute('data-infinite-initialized') === 'true') return;
    this.root.setAttribute('data-infinite-initialized', 'true');

    var nextUrl = this.getNextUrl();
    if (!nextUrl || (this.maxItems > 0 && this.getItems().length >= this.maxItems)) {
      if (this.pagination) this.pagination.hidden = true;
      this.finish();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      if (this.pagination) this.pagination.hidden = false;
      this.status.hidden = true;
      return;
    }

    if (this.pagination) this.pagination.hidden = true;
    this.status.hidden = false;
    this.setStatus('', false);

    var self = this;
    this.observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) self.loadMore();
      });
    }, { rootMargin: '0px 0px ' + this.rootMargin + 'px 0px' });

    this.observer.observe(this.status);
  };

  function init(context) {
    findRoots(context || document).forEach(function(root) {
      new InfiniteScroll(root).init();
    });
  }

  window.OwnLuxeInfiniteScroll = window.OwnLuxeInfiniteScroll || { init: init };

  if (!window.__ownluxeInfiniteScrollListenersAdded) {
    window.__ownluxeInfiniteScrollListenersAdded = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function(event) { init(event.target); });
  } else {
    init(document);
  }
})();
